import BaseRequestService from "@/modules/core/request/protected/BaseRequestService";
import env from "environment";

class CreditAssignmentRequestService extends BaseRequestService {
  constructor() {
    super({
      baseUrl: env.baseUrl + "/credit-assignments/requests"
    });
  }
}

const service = new CreditAssignmentRequestService();

export default service;
